import { Pipe, PipeTransform } from '@angular/core';
import { TipoVentaEnum } from '../../enums/tipo-venta.enum';

@Pipe({
  name: 'tipoVenta'
})
export class TipoVentaPipe implements PipeTransform {

  transform(tipoVenta: string): any {
    return this.getTipoVentaFormatted(tipoVenta);
  }

  getTipoVentaFormatted(tipoVenta: string): string {
    let tipoVentaAsText = '';
    switch (tipoVenta) {
      case TipoVentaEnum.PRESENCIAL_CANTIDAD.toString():
      case TipoVentaEnum.PRESENCIAL_CANTIDAD_CONEXION.toString():
      case TipoVentaEnum.PRESENCIAL_CANTIDAD_OFERTA.toString():
      case TipoVentaEnum.PRESENCIAL_SIMPLE.toString():
      case TipoVentaEnum.PRESENCIAL_CANTIDAD_TEMPORALIDAD.toString():
      case TipoVentaEnum.PRESENCIAL_CANTIDAD_FERIA.toString():
      case TipoVentaEnum.PRESENCIAL_DOBLE_CANTIDAD_CONEXION.toString():
      case TipoVentaEnum.PRESENCIAL.toString():
      tipoVentaAsText = 'Presencial';
      break;
      case TipoVentaEnum.INTERNET_SIMPLE.toString():
      case TipoVentaEnum.INTERNET_PROVEEDOR.toString():
      case TipoVentaEnum.INTERNET_INTEGRADOR.toString():
      case TipoVentaEnum.SERVICIO_WEB.toString():
      tipoVentaAsText = 'Internet';
      break;
    }
    return tipoVentaAsText;
  }
}
